import { gql } from '@apollo/client';

export const getPriceChangeAttributeLevelData = gql`
    query priceChangeAttributeLevelData(
        $dateRange: [JSONString]!
        $dimension: SamyaString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $frequency: String!
        $aggPeriod: String!
        $lagList: [Int]!
        $limit: Int
        $offset: Int!
        $metricType: SamyaString
        $priceType: SamyaString
        $comparisonPeriodType: SamyaString!
        $priceChangeThreshold: Float
    ) {
        priceChangeAttributeLevelData(
            dateRange: $dateRange
            dimension: $dimension
            attributeType: $attributeType
            filters: $filters
            lagList: $lagList
            limit: $limit
            offset: $offset
            metricType: $metricType
            frequency: $frequency
            aggPeriod: $aggPeriod
            priceType: $priceType
            comparisonPeriodType: $comparisonPeriodType
            priceChangeThreshold: $priceChangeThreshold
        ) {
            data {
                attributeName
                graphData {
                    lag
                    salesData
                    avgPrice
                    actualAvgPrice
                    __typename
                }
                __typename
            }
            comparisonTimePeriod {
                startTimestamp
                endTimestamp
            }
            count
            __typename
        }
    }
`;

export const getPriceChangeWeekLvlData = gql`
    query getPriceChangeWeekLvlData(
        $dateRange: [JSONString]!
        $attributeType: SamyaString!
        $filters: JSONString!
        $frequency: String!
        $dimension: SamyaString!
        $metricType: SamyaString!
        $priceType: SamyaString
        $comparisonPeriodType: SamyaString!
    ) {
        getPriceChangeWeekLvlData(
            dateRange: $dateRange
            attributeType: $attributeType
            filters: $filters
            dimension: $dimension
            frequency: $frequency
            metricType: $metricType
            priceType: $priceType
            comparisonPeriodType: $comparisonPeriodType
        ) {
            data {
                attributeName
                startTimestamp
                periodLabel
                priceCurrent
                pricePrevious
                percentagePriceChange
                __typename
            }
            count
            __typename
        }
    }
`;
